{
  "permissions": {
    "admin_devices": "Administrar Dispositivos",
    "manage_dashboards": "Gestionar Tableros",
    "manage_devices": "Gestionar Dispositivos",
    "manage_organizations": "Gestionar Organizaciones",
    "manage_reports": "Gestionar Informes",
    "manage_shared_dashboards": "Gestionar Tableros Compartidos",
    "manage_tokens": "Gestionar claves de API",
    "manage_users": "Gestionar Usuarios",
    "read_dashboards": "Leer Tableros",
    "read_devices": "Leer Dispositivos",
    "read_organizations": "Leer Organizaciones",
    "read_reports": "Leer Informes",
    "read_users": "Leer Usuarios"
  }
}
